/**
 * @file 视频组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';

export default class Video extends Component {
    static template = `
        <div class="video-wrap {{type}}" style="padding-top: {{ratio}};">
            <div
                s-if="playerState === 'cover'"
                class="cover"
                style="background: url({{cover}}) center / cover no-repeat #000;">
                <span on-click="play"></span>
            </div>
            <template s-else>
                <video
                    on-ended="playEnd"
                    on-play="playing"
                    src="{{playUrl}}"
                    poster="{{cover}}"
                    s-ref="video"
                    webkit-playsinline="true"
                    playsinline="true"
                    controls="true"></video>
            </template>
        </div>
    `;

    initData() {
        return {
            playerState: 'cover'
        };
    }

    updated() {
        if (this.data.get('playerState') === 'playing') {
            this.ref('video').play();
        }
        else if (this.data.get('playerState') === 'pause') {
            this.ref('video').pause();
        }
    }

    // 点击播放视频
    play() {
        this.data.set('playerState', 'playing');
        this.fire('play');
    }

    // 点击播放器的视频播放
    playing() {
        this.fire('playing');
    }

    // 视频播放结束
    playEnd() {
        this.fire('playend');
    }
}
